import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Entry } from 'contentful';
import { subscriptions, invoices, paymentIntents } from 'stripe';
import { Subscription, BehaviorSubject, Observable } from 'rxjs';

import { FunctionsService } from '../../services/functions/functions.service';
import { ProfileService } from '../../services/profile/profile.service';

@Component({
  selector: 'app-settings-subscription',
  templateUrl: './settings-subscription.component.html',
  styleUrls: ['./settings-subscription.component.scss'],
})
export class SettingsSubscriptionComponent implements OnInit, OnDestroy {
  @Input() public content: Entry<any> | undefined;
  @Input() public globalContent: Entry<any> | undefined;
  @Input() public subscriptionId: subscriptions.ISubscription['id'] | undefined;
  public subscription: subscriptions.ISubscription | undefined;
  public invoice: invoices.IInvoice | undefined;
  public paymentIntent: paymentIntents.IPaymentIntent | undefined;
  public upcomingInvoice: invoices.IInvoice | undefined;
  public waiting: boolean = false;
  public want: Observable<boolean>;
  private want$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private cancelID: string = '';
  private priceChangeDate: number = new Date('2020-04-25').getTime();
  private subscriptionLifecycleSubscription: Subscription | undefined;

  constructor(
    private fnService: FunctionsService,
    private profileService: ProfileService,
  ) {}

  ngOnInit() {
    this.want = this.want$.asObservable();
    if (!this.subscriptionId || !this.content) {
      return;
    }
    this.subscriptionLifecycleSubscription = this.profileService
      .subscriptionLifecycle(this.subscriptionId)
      .subscribe((state) => {
        this.subscription = state.subscription;
        this.invoice = state.invoice;
        this.paymentIntent = state.paymentIntent;
        if (state.subscription.status === 'active') {
          // == active subscription ==
        } else if (
          state.subscription.status === 'incomplete' &&
          state.invoice.status === 'open' &&
          state.paymentIntent.status === 'requires_action'
        ) {
          // == incomplete - open - requires_action ==
          // subscription is not yet active, action (SCA) required
          // trasitions to incomplete_expired in 24 hours if no action
        } else if (
          state.subscription.status === 'past_due' &&
          state.invoice.status === 'open' &&
          (state.paymentIntent.status === 'requires_action' ||
            state.paymentIntent.status === 'requires_payment_method')
        ) {
          // == past_due - open - requires_action | requires_paymen_method ==
          // subscription renew failed, requires action or new payment method
          // payment will be retried with the default method as configured
        } else {
          // == hide all other subscriptions (expired, cancelled, etc.) ==
          this.subscription = undefined;
        }
      });
    this.fnService.getUpcomingInvoice().then((invoice) => {
      this.upcomingInvoice = invoice;
    });
  }

  ngOnDestroy() {
    if (this.subscriptionLifecycleSubscription) {
      this.subscriptionLifecycleSubscription.unsubscribe();
    }
  }

  public confirmCancelSubscription(event) {
    if (event && this.cancelID) {
      this.waiting = true;
      this.want$.next(false);
      this.fnService
        .cancelSubscription(this.cancelID)
        .then(() => {
          this.cancelID = '';
        })
        .catch(() => {
          this.waiting = false; // for failed cancellations
        });
    }
  }

  public cancelSubscription(subscriptionId: subscriptions.ISubscription['id']) {
    if (this.subscription.start_date * 1000 < this.priceChangeDate) {
      this.cancelID = subscriptionId;
      this.want$.next(true);
    } else {
      this.waiting = true;
      this.fnService
        .cancelSubscription(subscriptionId)
        .then(() => {
          this.cancelID = '';
        })
        .catch(() => {
          this.waiting = false; // for failed cancellations
        });
    }
  }
}
